import React, { FC } from 'react';
import { Checkbox } from '../../../../components/checkbox/Checkbox';
import styles from './search_checkbox.module.scss';

type Props = {
  isSelected: boolean;
  title?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const SearchCheckbox: FC<Props> = ({
  isSelected,
  onClick,
  children,
  title,
}) => (
  <button
    className={styles.checkbox}
    type="button"
    onClick={onClick}
    title={title}
    data-test-id="search-checkbox"
  >
    <div className={styles.wrapper}>
      <span className={styles.icon}>
        <Checkbox checked={isSelected} />
      </span>
      <span className={styles.label}>{children}</span>
    </div>
  </button>
);
